import { httpClient } from "../../network/httpclient/HttpClientFactory";

const BASE = "/oil-supply/statistics";

// 1. 주유 통계 요약
const getSummary = (params) =>
  httpClient.get(`${BASE}/summary`, { params }).then((res) => res.data);

const getSummaryByEquipment = (equipmentId, params) =>
  httpClient
    .get(`${BASE}/summary/${equipmentId}`, { params })
    .then((res) => res.data);

// 2. 일별 주유 통계
const getDaily = (params) =>
  httpClient.get(`${BASE}/daily`, { params }).then((res) => res.data);

const getDailyByEquipment = (equipmentId, params) =>
  httpClient
    .get(`${BASE}/daily/${equipmentId}`, { params })
    .then((res) => res.data);

// 3. 월별 주유 통계
const getMonthly = (params) =>
  httpClient.get(`${BASE}/monthly`, { params }).then((res) => res.data);

const getMonthlyByEquipment = (equipmentId, params) =>
  httpClient
    .get(`${BASE}/monthly/${equipmentId}`, { params })
    .then((res) => res.data);

// 4. 장비별 주유 비용 효율
const getCostEfficiency = (params) =>
  httpClient.get(`${BASE}/cost-efficiency`, { params }).then((res) => res.data);

const getCostEfficiencyByEquipment = (equipmentId, params) =>
  httpClient
    .get(`${BASE}/cost-efficiency/${equipmentId}`, { params })
    .then((res) => res.data);

// 5. 전체 주유 통계 대시보드
const getDashboard = (params) =>
  httpClient.get(`${BASE}/dashboard`, { params }).then((res) => res.data);

// 6. 유종별 주유 통계
const getByOilType = (params) =>
  httpClient.get(`${BASE}/by-oil-type`, { params }).then((res) => res.data);

export default {
  getSummary,
  getSummaryByEquipment,
  getDaily,
  getDailyByEquipment,
  getMonthly,
  getMonthlyByEquipment,
  getCostEfficiency,
  getCostEfficiencyByEquipment,
  getDashboard,
  getByOilType,
};
